<template>
  <div class="endpoint">
    <h5 style="margin-bottom: 1px;">{{ endpoint.name }}</h5>
    <span v-if="endpoint.info" class="endpoint-info" v-html="endpoint.info"></span>
    <span>{{ endpoint.url }}</span>
    <div style="display: inline-grid" class="mx-2">
      <div v-for="(param, paramIndex) in endpoint.params"
        :key="paramIndex"
        :style="param.type === 'note' ? 'width: 300px;' :''"
        >
      <input
        v-if="typeof param.type == 'undefined'"
        class="hl_input--wrap my-1"
        type="text"
        :placeholder="param.placeholder ? param.placeholder : 'Parameters'"
        v-model="param.value"
      />
      <span v-if="param.type == 'note'" style="color:red">{{param.placeholder}}</span>
      </div>
    </div>
    <div v-if="loading[endpoint.name]" style="display: inline-block">
      <moon-loader :loading="true" size="24px" color="#007bff" />
    </div>
    <button v-else class="btn btn-primary" @click="endpoint.action(endpoint.name)">Fire!</button>
  </div>
</template>

<script>
export default {
    props: {
        endpointObject: Object,
        loading: Object
    },
    computed: {
        endpoint: {
            get() {
                return this.endpointObject
            },
            set(value) {
                this.$emit('update:endpointObject', value)
            }
        }
    }
}
</script>

<style>
.endpoint {
  border-bottom: 0.5px solid #ddd;
  padding: 16px;
}
.endpoint:last-child {
  border-bottom: none;
}
.endpoint-info {
  color: #00000066;
  font-size: 8pt;
  display: block;
  margin-bottom: 8px;
}
</style>
